export const getPlanCopy = (t, planId, options = {}) => {
  const copy = t(`plans.${planId}`, {
    returnObjects: true,
    defaultValue: {},
    ...options
  });

  return typeof copy === 'string' ? {} : copy;
};

export const getPlanFeatures = (t, planId, productType, options = {}) => {
  const { fallbackFeatures, ...translationOptions } = options;
  const copy = getPlanCopy(t, planId, translationOptions);
  if (copy.features) {
    return copy.features;
  }

  if (productType === 'ats') {
    return t('featureLists.atsPopup', { returnObjects: true }) || fallbackFeatures || [];
  }

  if (productType === 'tse') {
    return (
      t('featureLists.tse', { returnObjects: true, ...translationOptions }) ||
      fallbackFeatures ||
      []
    );
  }

  if (productType === 'bundle') {
    return (
      t('featureLists.bundle', { returnObjects: true, ...translationOptions }) ||
      fallbackFeatures ||
      []
    );
  }

  return fallbackFeatures || [];
};
